
<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
          <v-row class="d-flex justify-center mt-3">
              <v-col cols="4">
                <v-text-field
                  label="Pergunta"
                  v-model="form.filters.pergunta"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <sca-select-ativo
                :cols="2"
                :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo', label: 'Situação' }"
                v-model="form.filters.situacao"
              ></sca-select-ativo>
              <sca-date-picker
              :cols="2"
              label="Data Início"
              v-model="form.filters.dataInicio"
              removeIcon
              outlined
              dense
            ></sca-date-picker>
            <sca-date-picker
            :cols="2"
              v-model="form.filters.dataFim"
              label="Data Final"
              removeIcon
              outlined
              dense
            ></sca-date-picker>
          </v-row>
           <div class="text-center">
          <v-col cols="12">
            <sca-tooltip
              text="Buscar"
              icon="mdi-magnify"
              @click="buscarRelatorios"
            ></sca-tooltip>
            <sca-tooltip
              text="Limpar"
              icon="mdi-eraser"
              @click="resetForm"
            ></sca-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5 printable"
        :headers="table.headers"
        :items="table.items"
        :items-per-page="10"
        :footer-props="$footerProps"
        show-expand
        sort-by="dataAcao"
        :sort-desc="true"
        :expanded.sync="expanded"
      >
        <template v-slot:[`item.pergunta`]="{ item }">
          <td class="p-0 text-center" style="width: 25vw;">
            <span class="text-wrap p-0">{{ item.pergunta }}</span>
          </td>
        </template>
        <template v-slot:expanded-item="{ headers, item }">
          <td class="text-left blue-grey lighten-5" :colspan="headers.length">
            <p class="ml-4 my-0 text-wrap mx-70vw">
              {{ item.resposta }}
            </p>
          </td>
        </template>
        <template v-slot:[`item.situacao`]="{ item }">
          <sca-label-ativo :ativo="item.situacao" :config="{ labelAtivo: 'Ativo', labelInativo: 'Inativo' }"></sca-label-ativo>
        </template>
        <template v-slot:[`item.dataAcao`]="{ item }">
          {{ $formatarDataHora(item.dataAcao) }}
        </template>
        <template v-slot:[`item.acao`]="{ item }">
          {{ item.acao }}
        </template>
      </v-data-table>
      <sca-buttons
        v-if="table.items.length"
        actionText="Baixar PDF"
        cancelText="Baixar CSV"
        @click="baixarRelatorioPdf"
        @cancel="baixarCSVRelatorio"
      ></sca-buttons>
    </v-container>
  </div>
</template>

<script>
  import pageLoadingMixin from "mixins/page-loading.mixin";
  import RelatorioDeLog from "~/services/relatorios-log/manter-faq-log.service"
  export default {
    name: "RelatorioLogFaqSerie",
    mixins: [pageLoadingMixin, RelatorioDeLog],
    data: () => ({
      onReport: false,
      expanded: [],
      form: {
        filters: {
          pergunta: null,
          situacao: null,
          dataInicio: null,
          dataFim: null,
        },
        lists: {
            listRelatorios: [],
        },
      },
      table: {
        page: 1,
        items: [],
        headers: [
          { text: "Pergunta", align: "center", value: "pergunta" },
          { text: "Resposta", align: "center", value: "data-table-expand"},
          { text: "Situação", align: "center", value: "situacao" },
          { text: "Data/Hora da ação", align: "center", value: "dataAcao" },
          { text: "Ação", align: "center", value: "acao" },
        ],
      }

    }),
    methods: {
      buscarRelatorios() {
        const isValid = this.validarDatas();
        if (!isValid) return;
        if (!this.verificarFiltrosPreenchidos()) return;
        this.showPageLoading();
        this.table.items = [];
        this.$obterRelatorioLogFaq({params: this.form.filters})
          .then(({data}) => this.processarRespostaRelatorio(data));
      },
      validarDatas() {
      const { dataInicio, dataFim } = this.form.filters;

      if (dataInicio && dataFim) {
        if (new Date(dataFim) < new Date(dataInicio)) {
          this.$notifyWarning("A Data Final não pode ser anterior à Data Início");
          return false;
        }
        if (new Date(dataInicio) > new Date(dataFim)) {
          this.$notifyWarning("A Data Início não pode ser posterior à Data Final");
          return false;
        }
      }
      return true;
    },

    verificarFiltrosPreenchidos() {
      const { faq, situacao, dataInicio, dataFim, pergunta } = this.form.filters;
      if (!faq && situacao == null && !dataInicio && !dataFim && !pergunta) {
        this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
        return false;
      }
      return true;
    },

    async baixarCSVRelatorio() {
      this.showPageLoading();
      try {
      const { data } = await this.$obterRelatorioLogCSVFaq({ params: this.form.filters });
      this.$baixarRelatorioCSV(data, `SCA.RelatórioDeLogDeFaqCSV`);
      this.$notifySuccess("Operação realizada com sucesso.");
      } finally {
      this.hidePageLoading();
      }
    },

    async baixarRelatorioPdf() {
      this.showPageLoading();
      try {
      const { data } = await this.$obterRelatorioLogPDFFaq({ params: this.form.filters });
      const url = URL.createObjectURL(data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "SCA.RelatórioDeLogDeFaq.pdf");
      document.body.appendChild(link);
      link.click();
      this.$notifySuccess("Operação realizada com sucesso.");
      } finally {
      this.hidePageLoading();
      }
    },

    processarRespostaRelatorio(data) {
      this.table.items = [];
      this.$nextTick(() => this.table.items = data.lista );
    },

    resetForm() {
      this.form.filters.dataInicio = null;
      this.form.filters.dataFim = null;
      this.form.filters.pergunta = null;

      this.$nextTick(() => {
        this.$set(this.form.filters, 'dataInicio', null);
        this.$set(this.form.filters, 'dataFim', null);
      });
      this.form.filters.faq = null;
      this.form.filters.situacao = null;

      this.form.lists.listRelatorios = [];
      this.table.items = [];
      this.expanded = [];
    }
  },
};
</script>
